import _ from 'lodash';
import { SDLUtil, RequestUtil, StringUtil } from '@/utils';

const setHelpObjList = ({ commit }, data) => {
  commit('SET_HELP_OBJ_LIST', data);
};
const setHelpObj = ({ commit }, data) => {
  commit('SET_HELP_OBJ', data);
};

export default {
  async SELECT_HELP_OBJ_LIST(store, param) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/auth/help-list?${StringUtil.queryStringfy(param)}`);

    setHelpObjList(store, response.data);
  },

  async SELECT_HELP_OBJ(store, param) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/auth/help?${StringUtil.queryStringfy(param)}`);

    setHelpObj(store, response.data);
  },

  async UPDATE_HELP_OBJ(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/auth/help`, param);
  },

  async DELETE_HELP_OBJ(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/auth/help/delete`, param);
  },

  async INSERT_COA_LOG(store, cspType) {
    const param = {
      logMsg : cspType.concat('_').concat(SDLUtil.getLoginedUserInfo().loginId).concat('_Login'),
      msgType : 'Login',
      regrId : SDLUtil.getLoginedUserInfo().userId
    };

    await RequestUtil.post(`${SDLUtil.API_URL}/cop/coa/logs/insertCoaLog`, param);
  }
};



// WEBPACK FOOTER //
// ./src/vuex/common/common/commonActions.js